const verifyCaptchaToken = crm => async ({ token }) => {
	if (!token) {
		return;
	}

	return await crm.verifyCaptchaToken({ token });
};

export default verifyCaptchaToken;
